import { flatten } from 'lodash'

const routes = (() => {
  const requireRoutes = require.context('.', true, /^((?!store).)*\.js$/)
  return flatten(
    requireRoutes
      .keys()
      .filter(fileName => fileName !== './router.js')
      .map(fileName => requireRoutes(fileName).default)
  )
})()


export default routes.filter(el => el !== undefined);
